<tool-drawer-container [shouldShowToggleBtn]="false">
  <tool-header
    class="tool-header"
    headerTitle="Course Grade Estimation"
    [pathBreadcrumbs]="
      toolListService.getHelpPagePathBreadcrumbs('course_grade_estimation')
    "
  ></tool-header>

  <div class="tool-content-container main-content">
    <div class="tool-description">
      Below are the step by step instructions on how to use Course Grade
      Estimation Tool. The Course Grade Estimation Tool lets you view the grade
      range or passing probability for a target course.
    </div>

    <div class="tool-div">
      <div class="left-align-div">
        <h1 class="h1-header">
          Success Metrics Section
          <i class="fa-solid fa-arrow-right"></i> Course Grade Estimation
        </h1>

        <div class="buttons-nav">
          <div class="example-button-row">
            <nav-page-link
              text="Estimation Filter Guide"
              targetId="formguide"
              tooltipMessage="Navigate down"
            ></nav-page-link>
            <span> &nbsp; | &nbsp; </span>
            <nav-page-link
              text="Course Grade Estimation Table Result"
              targetId="results"
              tooltipMessage="Navigate down"
            ></nav-page-link>
          </div>
        </div>

        <!---------- Course Grade Estimation Tool At First Glance ---------->
        <h3 class="h3-second-header">
          Course Grade Estimation Tool At First Glance
        </h3>

        <ol class="ordered-list">
          <li>
            Once you get to the page, you will be able to see something like the
            image below in Figure 28.
          </li>
        </ol>

        <div>
          <br />
          <img
            class="small-pics"
            [(src)]="env['logo_paths']['helpPageCourseEstimationFig28']"
            alt=""
          />
          <p class="picture-caption">
            Figure 28: Course Grade Estimation Tool Page
          </p>
        </div>

        <div id="formguide"></div>
        <br />
        <mat-divider></mat-divider>
        <br />

        <!---------- Course Grade Estimation Form Guide ---------->
        <h3 class="h3-second-header">
          Course Grade Estimation Form Submission
        </h3>

        <ol class="ordered-list">
          <li>
            Enter a Student ID (Used to populate the Taken Courses box, Cohort
            and Program)
          </li>
          <li>
            Select the Target Semester (Default value is applied here based on
            the student's cohort year)
          </li>
          <li>Select the Target Course (Example: ENC 1102)</li>
          <li>The Taken Courses box (Figure29a)</li>
          <ul>
            <li>
              The taken courses box should have been filled with the student’s
              course history based on the selected target semester. Once the
              student's id and target semester has been entered it will be
              automatically populated.
            </li>
            <li>
              You can delete a course by clicking on the 'x' button next to the
              course number.
            </li>
            <li>
              You can also add courses by choosing a course number and grade.
            </li>
            <ul>
              <li>
                After that click 'Add Course' to add that course to the course
                history box.
              </li>
            </ul>
            <div>
              <img
                class="set-img-width-sm"
                [(src)]="env['logo_paths']['helpPageCourseEstimationFig29']"
                alt=""
              />
              <p class="picture-caption">
                Figure 29: Example Taken Courses populated values
              </p>
            </div>
          </ul>
          <li>
            * Lastly, click on the ‘Submit’ button to generate results for
            Course Grade Estimation.
          </li>
        </ol>
      </div>

      <div class="left-align-div">
        <ul class="unordered-list">
          <li>
            Below is an example for course recommender form filled with values.
          </li>
        </ul>
        <div>
          <img
            class="set-img-width-sm"
            [(src)]="env['logo_paths']['helpPageCourseEstimationFig29a']"
            alt=""
          />
          <p class="picture-caption">Figure 29a: Estimation Filter (1)</p>
        </div>
      </div>

      <div class="left-align-div">
        <div>
          <img
            class="set-img-width-sm"
            [(src)]="env['logo_paths']['helpPageCourseEstimationFig29b']"
            alt=""
          />
          <p class="picture-caption">Figure 29b: Estimation Filter (2)</p>
        </div>
      </div>

      <!--------------- Results After Form Submission Explanation --------------->
      <div class="left-align-div" id="results">
        <br />
        <mat-divider></mat-divider>
        <br />

        <h3 class="h3-second-header">Results After Form Submission</h3>

        <ul class="unordered-list">
          <li>
            After submitting the form, you will get a table that displays the
            grade range estimated for the target course along with some
            additional information.
          </li>
          <li>
            You can delete results row if need to by clicking on the 'x' button
            in the Actions column in the table.
          </li>
          <br />
          <div>
            <img
              class="set-img-width-med"
              [(src)]="env['logo_paths']['helpPageCourseEstimationFig30']"
              alt=""
            />
            <p class="picture-caption">
              Figure 30: Course Grade Estimation Results
            </p>
          </div>
        </ul>
      </div>
    </div>
  </div>

  <related-links
    class="right-sidenav"
    [links]="
      toolListService.getSuccessMetricsRelatedLinkBasedOnTool(
        'Course Grade Estimation',
        true
      )
    "
  ></related-links>
</tool-drawer-container>
